import { useMediaQuery } from '@hooks/useMediaQuery'
import { theme } from '@ui/style'

const useIsShowAds = () => {
	// const isShowDesktopL = useMediaQuery(`only screen and (min-width: ${theme.breakpoint.xl}px)`)
	// const isShowDesktopS = useMediaQuery(
	// 	`only screen and (min-width: ${theme.breakpoint.lg}px) and (max-width: ${
	// 		theme.breakpoint.xl - 1
	// 	}px)`,
	// )
	const isShowDesktop = useMediaQuery(`only screen and (min-width: ${theme.breakpoint.lg}px)`)
	const isShowTablet = useMediaQuery(
		`only screen and (min-width: ${theme.breakpoint.md}px) and (max-width: ${
			theme.breakpoint.lg - 1
		}px)`,
	)
	const isShowMobile = useMediaQuery(`only screen and (max-width: ${theme.breakpoint.md - 1}px)`)

	return {
		isShowDesktop,
		isShowTablet,
		/** mw 일 경우에는 항상 true */
		isShowMobile,
	}
}
export default useIsShowAds
